module.exports = __webpack_public_path__ + "media/images/logo-ac92828cd112dce06cb0b75fa6d49898.svg";